import { useState } from "react";
import { SoftphoneSipConfig } from "./useSoftphoneConfig";

export type UseMakeCall = {
  selectedNumber: string;
  dialLoading: boolean;
  dialError: string;
  requestDial: (number: string) => void;
  cancelDial: () => void;
  confirmDial: () => void;
};

export function useMakeCall(
  sipConfig: SoftphoneSipConfig | null,
  placeCall: (number: string, variaveis?: string) => void
): UseMakeCall {
  const [selectedNumber, setSelectedNumber] = useState("");
  const [dialError, setDialError] = useState("");

  function requestDial(number: string) {
    setDialError("");
    setSelectedNumber(number);
  }

  function cancelDial() {
    setDialError("");
    setSelectedNumber("");
  }

  function confirmDial() {
    if (!selectedNumber) return;
    if (!sipConfig?.extension) {
      setDialError("O ramal do softphone ainda nao esta disponivel.");
      return;
    }

    // A chamada e originada pelo proprio softphone via postMessage (SIP INVITE),
    // sem dependencia da API REST do PABX. variaveis vazio = sem header extra.
    placeCall(selectedNumber, "");
    setSelectedNumber("");
  }

  // dialLoading mantido por compatibilidade com o DialConfirmationDialog; o
  // postMessage e fire-and-forget, entao nunca ha estado de carregamento.
  return { selectedNumber, dialLoading: false, dialError, requestDial, cancelDial, confirmDial };
}
